import ApiService from '@/services/core/api.service'

const FacebookLeadService = {
  async get (query) {
    return ApiService.get(`agent/facebook-leads?${query}`)
  },

  async post (payload) {
    return ApiService.post('agent/facebook-leads', payload)
  },

  async put (payload) {
    return ApiService.put(`agent/facebook-leads/${payload.id}`, payload)
  }
}

export default FacebookLeadService
